import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M402-402 143-507q-13-5-19-15.5t-6-21.5 6.5-21.5T144-581l614-228q12-5 23-2t19 11 11 19-2 23L581-144q-5 13-15.5 19.5T544-118t-21.5-6-15.5-19zm140 134 162-436-436 162 196 78zm-78-196" }, null, -1)
  ])))
}
export default { render: render }